<template>
	<div class="main user-layout-register">
		<h3><span></span></h3>
		<a-form ref="formRegister" :form="form" id="formRegister" style="margin-top: 50px;">
			<a-form-item>
				<a-input size="large" type="text" placeholder="请输入登录名" v-decorator="['loginName', {rules: [{ required: true, message: '请输入登录名' }], validateTrigger: ['change', 'blur']}]"></a-input>
			</a-form-item>
			<a-form-item>
				<a-input size="large" type="text" placeholder="请输入系统绑定的邮箱" v-decorator="['email', {rules: [{ required: true, type: 'email', message: '请输入系统绑定的邮箱' }], validateTrigger: ['change', 'blur']}]"></a-input>
			</a-form-item>
			<a-form-item>
				<a-button size="large" type="primary" htmlType="submit" class="register-button" :loading="registerBtn"
				 @click.stop.prevent="handleSubmit" :disabled="registerBtn">重置密码
				</a-button>
				<router-link class="login" :to="{ name: 'login' }">使用已有账户登录</router-link>
			</a-form-item>

		</a-form>
	</div>
</template>

<script>
	import {
		getSmsCaptcha,
		forget_pwd
	} from '@/api/login'
	import {
		deviceMixin
	} from '@/store/device-mixin'

	const levelNames = {
		0: '低',
		1: '低',
		2: '中',
		3: '强'
	}
	const levelClass = {
		0: 'error',
		1: 'error',
		2: 'warning',
		3: 'success'
	}
	const levelColor = {
		0: '#ff0000',
		1: '#ff0000',
		2: '#ff7e05',
		3: '#52c41a'
	}
	export default {
		name: 'Register',
		components: {},
		mixins: [deviceMixin],
		data() {
			return {
				form: this.$form.createForm(this),

				state: {
					time: 60,
					smsSendBtn: false,
					passwordLevel: 0,
					passwordLevelChecked: false,
					percent: 10,
					progressColor: '#FF0000'
				},
				registerBtn: false
			}
		},
		computed: {
			passwordLevelClass() {
				return levelClass[this.state.passwordLevel]
			},
			passwordLevelName() {
				return levelNames[this.state.passwordLevel]
			},
			passwordLevelColor() {
				return levelColor[this.state.passwordLevel]
			}
		},
		methods: {

			handlePasswordLevel(rule, value, callback) {
				let level = 0

				// 判断这个字符串中有没有数字
				if (/[0-9]/.test(value)) {
					level++
				}
				// 判断字符串中有没有字母
				if (/[a-zA-Z]/.test(value)) {
					level++
				}
				// 判断字符串中有没有特殊符号
				if (/[^0-9a-zA-Z_]/.test(value)) {
					level++
				}
				this.state.passwordLevel = level
				this.state.percent = level * 30
				if (level >= 2) {
					if (level >= 3) {
						this.state.percent = 100
					}
					callback()
				} else {
					if (level === 0) {
						this.state.percent = 10
					}
					callback(new Error('密码强度不够'))
				}
			},

			handlePasswordCheck(rule, value, callback) {
				const password = this.form.getFieldValue('password')
				console.log('value', value)
				if (value === undefined) {
					callback(new Error('请输入密码'))
				}
				if (value && password && value.trim() !== password.trim()) {
					callback(new Error('两次密码不一致'))
				}
				callback()
			},

			handlePhoneCheck(rule, value, callback) {
				console.log('handlePhoneCheck, rule:', rule)
				console.log('handlePhoneCheck, value', value)
				console.log('handlePhoneCheck, callback', callback)

				callback()
			},

			handlePasswordInputClick() {
				if (!this.isMobile) {
					this.state.passwordLevelChecked = true
					return
				}
				this.state.passwordLevelChecked = false
			},

			handleSubmit() {
				this.form.validateFields((err, values) => {
					if (!err) {
						forget_pwd(values).then(res => {
							if (res.code === 200) {
								this.$message.success(res.msg)
							} else {
								this.form.resetFields()
								this.$message.success(res.msg)
							}
						}).catch(() => {
							this.$message.error('系统错误，请稍后再试')
							this.$message.success(res.msg)
						})
					}
				})
			},

			getCaptcha(e) {
				e.preventDefault()
				const {
					form: {
						validateFields
					},
					state,
					$message,
					$notification
				} = this

				validateFields(['mobile'], {
						force: true
					},
					(err, values) => {
						if (!err) {
							state.smsSendBtn = true

							const interval = window.setInterval(() => {
								if (state.time-- <= 0) {
									state.time = 60
									state.smsSendBtn = false
									window.clearInterval(interval)
								}
							}, 1000)

							const hide = $message.loading('验证码发送中..', 0)

							getSmsCaptcha({
								mobile: values.mobile
							}).then(res => {
								setTimeout(hide, 2500)
								$notification['success']({
									message: '提示',
									description: '验证码获取成功，您的验证码为：' + res.result.captcha,
									duration: 8
								})
							}).catch(err => {
								setTimeout(hide, 1)
								clearInterval(interval)
								state.time = 60
								state.smsSendBtn = false
								this.requestFailed(err)
							})
						}
					}
				)
			},
			requestFailed(err) {
				this.$notification['error']({
					message: '错误',
					description: ((err.response || {}).data || {}).message || '请求出现错误，请稍后再试',
					duration: 4
				})
				this.registerBtn = false
			}
		},
		watch: {
			'state.passwordLevel'(val) {
				console.log(val)
			}
		}
	}
</script>
<style lang="less">
	.user-register {

		&.error {
			color: #ff0000;
		}

		&.warning {
			color: #ff7e05;
		}

		&.success {
			color: #52c41a;
		}

	}

	.user-layout-register {
		.ant-input-group-addon:first-child {
			background-color: #fff;
		}
	}
</style>
<style lang="less" scoped>
	.user-layout-register {

		&>h3 {
			font-size: 16px;
			margin-bottom: 20px;
		}

		.getCaptcha {
			display: block;
			width: 100%;
			height: 40px;
		}

		.register-button {
			width: 50%;
		}

		.login {
			float: right;
			line-height: 40px;
		}
	}
</style>
